<template>
  <div class="panel-box">
    <!-- <h3 @click="isCollapse">成像{{isSetting?'设置':'数据'}}
      <u-icon :name="showSightSetting ? 'ChevronDownMed' : 'ChevronRightMed'"></u-icon>
    </h3> -->
    <div :class="isSetting?'panel-setting':''"
         v-show="showSightSetting">
      <!-- 成像模式 -->
      <div v-show="hasConfig('viewMode')">
        <h4>成像模式: {{sight.viewMode}}
          <span v-if="isSetting"
                class="radio">
            <input type="radio"
                   v-model="sight.viewMode"
                   value="both"
                   checked
                   class="option-radio"
                   id="both">
            <label for="both">双眼</label>
            <input type="radio"
                   v-model="sight.viewMode"
                   value="OD"
                   class="option-radio"
                   id="OD">
            <label for="OD">右眼</label>
            <input type="radio"
                   v-model="sight.viewMode"
                   value="OS"
                   class="option-radio"
                   id="OS">
            <label for="OS">左眼</label>
          </span>
        </h4>
      </div>
      <!-- 视标大小 -->
      <div v-show="hasConfig('baseAcuity')">
        <h4>视标大小：{{sight.baseAcuity.toFixed(1)}}
          <vue-numeric-input v-if="isSetting"
                             v-model.number="sight.baseAcuity"
                             :precision="1"
                             :min=".1"
                             :max="1.0"
                             :step=".1" />
        </h4>
      </div>

      <div v-show="hasConfig('frequence')">
        <h4>闪烁频率(OD)：{{sight.OD.frequence}}
          <vue-numeric-input v-if="isSetting"
                             v-model.number="sight.OD.frequence"
                             :min="frequenceRange[0]"
                             :max="frequenceRange[1]"
                             :step="1" />
        </h4>
      </div>

      <!-- <h4>背景</h4> -->
      <div v-show="hasConfig('frequence')">
        <h4>闪烁频率(OS)：{{sight.OS.frequence}}
          <vue-numeric-input v-if="isSetting"
                             v-model.number="sight.OS.frequence"
                             :min="frequenceRange[0]"
                             :max="frequenceRange[1]"
                             :step="1" />
        </h4>
      </div>
      <!-- <h4>背景</h4> -->
    </div>
    <!-- <hr> -->
  </div>
</template>

<script>
import { FREQUENCE_RANGE } from '@/therapy/constants/sight'
export default {
  props: {
    isSetting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sight: this.$store.state.therapy.sight,
      showSightSetting: true,
      frequenceRange: FREQUENCE_RANGE,
    }
  },
  created() {
  },
  methods: {
    hasConfig(configName) {
      let g = this.$store.state.therapy.globalConfig
      return g.Sight && g.Sight.includes(configName)
      // return this.config.includes(configName)
    },
    isCollapse() {
      // this.showSightSetting = !this.showSightSetting
    },
  },
}
</script>
